module.exports = {
    DELETE_NOTICE: "Are you sure you want to delete this notice?",
    MESSAGE_LIMIT_ERROR: "Message limit exceeded! The content has been limited to 250 characters"
}